import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36ae0c98&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=36ae0c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae0c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ae0c98')) {
      api.createRecord('36ae0c98', component.options)
    } else {
      api.reload('36ae0c98', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36ae0c98&scoped=true&", function () {
      api.rerender('36ae0c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Timeline/index.vue"
export default component.exports